import { Card, CardContent } from "../../client/components/ui/card";
import { CardSectionHeader } from "../../client/components/ui/card-section-header";
import AnimatedMetric from "../../client/components/AnimatedMetric";
import { BorderBeam } from "../../client/components/ui/border-beam";
import { useDashboardData } from "./DashboardDataContext";

export default function NetPnlWidget() {
  const { metrics, isDark, t } = useDashboardData();
  if (!metrics) return null;
  return (
    <div className="relative overflow-hidden p-[1.5px] rounded-xl h-full">
      <Card className="h-full flex flex-col relative z-10">
        <CardSectionHeader label={t.dashboard.netPnlLabel} isDark={isDark} compact />
        <CardContent className="px-4 pb-4 pt-2 flex-1 flex flex-col justify-center min-w-0">
          <AnimatedMetric
            value={metrics.totalPnl}
            format="currency"
            prefix={metrics.totalPnl >= 0 ? "+" : undefined}
            suffix=" $"
            className={`block truncate text-xl sm:text-2xl font-bold font-mono leading-none tabular-nums ${metrics.totalPnl >= 0 ? "text-pnlPositive" : "text-pnlNegative"}`}
          />
          <div className="mt-1.5 truncate text-xs text-muted-foreground font-medium">{metrics.totalTrades} trades</div>
        </CardContent>
      </Card>
      <BorderBeam duration={3} />
    </div>
  );
}
